import angular from 'angular';
import moment from 'moment';
import adminpulse from '@/shared/utils/adminpulse';
import { v4 as uuidv4 } from 'uuid';

angular
  .module('cxRelations')
  .controller('GenerateRelationDocumentDialogCtrl', [
    '$element',
    'translateListFilter',
    '$translate',
    'relationNameFilter',
    'flySvc',
    '$http',
    'appUrls',
    'close',
    'relationId',
    'language',
    'companyId',
    'relationType',
    'templateTypes',
    'FileSaver',
    'Blob',
    generateRelationDocumentDialogCtrl,
  ]);

function generateRelationDocumentDialogCtrl(
  $element,
  translateListFilter,
  $translate,
  relationNameFilter,
  flySvc,
  $http,
  appUrls,
  close,
  relationId,
  language,
  companyId,
  relationType,
  templateTypes,
  FileSaver,
  Blob,
) {
  var vm = this;
  vm.loading = true;
  vm.preview = null;
  vm.loadingPreview = false;
  vm.templates = [];
  vm.template = null;
  vm.hasEmptyTags = false;
  vm.templateTags = [];
  vm.saving = false;
  vm.generating = false;
  vm.validatingTemplate = false;
  vm.linkedRelations = null;
  vm.hasQrCodeTag = false;

  vm.document = {
    documentDate: moment
      .utc()
      .startOf('day')
      .toDate(),
    relationId: relationId,
    documentStartDate: null,
    addQrCode: false,
    desiredDocumentId: uuidv4(),
  };

  $http
    .get(`${appUrls.api}/api/documentTemplate/Templates`, {
      params: {
        templateTypes: templateTypes || [99],
        companyId,
        relationType,
      },
    })
    .then(function(result) {
      vm.templates = (result.data || []).map(x => ({
        ...x,
        group: translateListFilter(x.templateType, 'TemplateType'),
      }));
      if (typeof language === 'string' && language) {
        vm.templates = vm.templates.filter(
          x => x.languageCode.toLowerCase() === language.toLowerCase(),
        );
      }
      vm.loading = false;
    });

  vm.cancel = function() {
    $element.modal('hide');
    close(null, 500);
  };

  vm.generate = function(type) {
    if (!vm.template || !vm.template.id) return;
    vm.saving = true;

    const model = vm.getGenerateModel();

    if (type === 'preview') {
      vm.loadingPreview = true;
      $http.post(appUrls.api + '/Api/RelationDocument/Preview', model).then(
        function(result) {
          vm.loadingPreview = false;
          vm.saving = false;
          if (result && result.data) {
            vm.preview = result.data.file;
          }
        },
        function(error) {
          vm.saving = false;
          vm.loadingPreview = false;
          flySvc.error(error);
        },
      );
    } else if (type === 'download') {
      vm.downloading = true;
      model.asPdf = false;
      $http.post(appUrls.api + '/Api/RelationDocument/download', model).then(
        function(result) {
          vm.downloading = false;
          vm.saving = false;
          if (result && result.data) {
            var arrayBuffer = adminpulse.base64ToArrayBuffer(result.data.file);
            var blob = new Blob([arrayBuffer], { type: result.data.mime });
            FileSaver.saveAs(blob, result.data.name);
          }
        },
        function(error) {
          vm.saving = false;
          vm.downloading = false;
          flySvc.error(error.code, error.parameters);
        },
      );
    } else if (type === 'downloadPdf') {
      vm.downloadingPdf = true;
      model.asPdf = true;
      $http.post(appUrls.api + '/Api/RelationDocument/download', model).then(
        function(result) {
          vm.downloadingPdf = false;
          vm.saving = false;
          if (result && result.data) {
            var arrayBuffer = adminpulse.base64ToArrayBuffer(result.data.file);
            var blob = new Blob([arrayBuffer], { type: result.data.mime });
            FileSaver.saveAs(blob, result.data.name);
          }
        },
        function(error) {
          vm.saving = false;
          vm.downloadingPdf = false;
          flySvc.error(error.code, error.parameters);
        },
      );
    } else if (type === 'email') {
      vm.preparingEmail = true;
      $http.post(appUrls.api + '/Api/RelationDocument/PrepareForEmail', model).then(
        function(result) {
          vm.preparingEmail = false;
          vm.saving = false;
          if (result && result.data) {
            close(
              {
                document: result.data,
                openEmailDialog: true,
              },
              500,
            );
            $element.modal('hide');
          }
        },
        function(error) {
          vm.saving = false;
          vm.preparingEmail = false;
          flySvc.error(error.code, error.parameters);
        },
      );
    } else if (type === 'save') {
      vm.generating = true;
      $http.post(appUrls.api + '/Api/RelationDocument/Generate', model).then(
        function(result) {
          vm.saving = false;
          if (result && result.data) {
            vm.generating = false;
            close(
              {
                document: result.data,
                openEmailDialog: false,
              },
              500,
            );
            $element.modal('hide');
          }
        },
        function(error) {
          vm.saving = false;
          vm.generating = false;
          flySvc.error(error);
        },
      );
    }
  };

  vm.getGenerateModel = function() {
    const model = angular.copy(vm.document);
    if (model.documentDate instanceof Date) model.documentDate = moment.utc(model.documentDate);
    if (model.documentStartDate && model.documentStartDate instanceof Date)
      model.documentStartDate = moment.utc(model.documentStartDate);
    model.tags = (vm.templateTags || []).reduce((o, e) => {
      if (!!e.value) {
        o[e.tag] = e.value;
      }
      return o;
    }, {});
    return model;
  };

  vm.loadLinkedRelations = function() {
    if (vm.linkedRelations) return;
    vm.linkedRelations = [];
    $http.get(`${appUrls.api}/api/RelationLink/Get/${relationId}`).then(function(result) {
      let activeRelationLinks = [];

      const now = moment.utc();

      result.data.forEach(linkedRelation => {
        const endDate = linkedRelation.info?.endDate ?? linkedRelation.info?.mandateEndDate;

        if (!endDate || now.isBefore(moment.utc(endDate))) {
          activeRelationLinks.push(linkedRelation);
        }
      });

      let grouped = Object.groupBy(
        activeRelationLinks,
        x => x.target.id + '/' + (x.info && x.info.representedBy),
      );

      let labelFor = link =>
        translateListFilter(link.linkType, 'linktypeto') +
        (link.info && link.info.position
          ? ': ' + translateListFilter(link.info && link.info.position, 'companyownerposition')
          : '');

      vm.linkedRelations = Object.values(grouped)
        .map(x => ({
          name: relationNameFilter(x[0].target),
          linkTypes: x
            .map(link => labelFor(link))
            .sort()
            .join(', '),
          representative: x[0].info && x[0].info.representedBy,
        }))
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(x => {
          let label = x.name + ' (' + x.linkTypes + ')';
          let self = { name: x.name, label };
          let representative = x.representative
            ? {
                name: x.representative,
                label:
                  '-  ' +
                  x.representative +
                  ': ' +
                  $translate.instant('RepresentativeOf', { relation: x.name }),
              }
            : null;
          return representative ? [self, representative] : [self];
        })
        .reduce((a, b) => a.concat(b), []);
    });
  };

  vm.templateChanged = function() {
    if (!vm.template?.id) {
      vm.template = null;
      vm.document.templateId = null;
      vm.document.documentStartDate = null;
      vm.templateTags = [];
      vm.preview = null;
      vm.loadingPreview = false;

      return;
    }
    vm.document.templateId = vm.template.id;
    vm.document.documentStartDate = null;

    const model = vm.getGenerateModel();
    vm.validatingTemplate = true;
    vm.templateTags = [];
    vm.hasEmptyTags = false;
    vm.hasQrCodeTag = false;

    $http.post(appUrls.api + '/api/RelationDocument/ResolveTemplateTags', model).then(
      function(result) {
        vm.validatingTemplate = false;
        if (result && result.data) {
          if (result.data.assignmentStartDate) {
            vm.document.documentStartDate = moment
              .utc(result.data.assignmentStartDate)
              .startOf('day')
              .toDate();
          }

          vm.hasEmptyTags = !!result.data.emptyTags && result.data.emptyTags.length;
          result.data.emptyTags.forEach(tag => {
            //Lower case and remove {}
            const key = tag.toLowerCase().replace(/[{}]/, '');

            if (key === 'document.qr') {
              vm.hasQrCodeTag = true;
              return;
            }
            if (key === 'representedby' && vm.linkedRelations === null) {
              vm.loadLinkedRelations();
            }
            vm.templateTags.push({
              tag,
              key,
              info: translateListFilter(`{${key}}`, 'mailplaceholder', ''),
              value: '',
            });
          });
        }
      },
      function(error) {
        vm.validatingTemplate = false;
        flySvc.error(error.code, error.parameters);
      },
    );
  };
}
